<template>
  <v-list-item>
    <v-list-item-avatar :color="avatarColor">
      <v-icon dark>mdi-account-group</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>
        {{ conf.name }} &lt;{{ conf.exten }}&gt;
      </v-list-item-title>
      <v-list-item-subtitle class="caption">
        <v-icon small>mdi-account-switch</v-icon>
        {{ $t('confr.capacity') }}: {{ conf.maxusers }}
      </v-list-item-subtitle>
      <v-list-item-subtitle class="caption">
        <v-icon small>mdi-account-multiple-check</v-icon>
        {{ $t('confr.members') }}: {{ memNum }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom light>
        <template v-slot:activator="{ on }">
          <v-btn class="watch-btn" icon small v-on="on" @click="toggleWatch">
            <v-icon small :color="conf.watch ? 'green' : 'grey lighten-2'">
              mdi-eye{{ conf.watch ? '' : '-off' }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ $t('confr.tooltip.watch') }}
        </span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex'
import API from '@/api'
import events from 'Store/events'

export default {
  name: 'conference-list-item',
  props: {
    conf: {
      type: Object,
      required: true
    }
  },
  computed: {
    avatarColor: function () {
      return this.memNum > 0
        ? 'green'
        : 'primary'
    },
    memNum: function () {
      return this.conf.members?.length ?? 0
    }
  },
  methods: {
    ...mapActions({
      watchToggle: 'conferences/toggleWatch'
    }),
    toggleWatch: function () {
      API.watchConference(this.conf.id, !this.conf.watch).then(() => {
        this.watchToggle(this.conf)
      }).catch(err => {
        this.dbg(err)
        events.pubError('API failed to update conference watch value.')
      })
    }
  }
}
</script>

<style scoped>
</style>
